module.exports = __webpack_public_path__ + "img/star-full-prm.a5858594.svg";